var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopyLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4998 6V3C7.4998 2.44772 7.94752 2 8.4998 2H20.4998C21.0521 2 21.4998 2.44772 21.4998 3V17C21.4998 17.5523 21.0521 18 20.4998 18H17.4998V20.9991C17.4998 21.5519 17.0499 22 16.493 22H4.50666C3.95059 22 3.5 21.5554 3.5 20.9991L3.5026 7.00087C3.5027 6.44811 3.95264 6 4.50942 6H7.4998ZM5.50242 8L5.50019 20H15.4998V8H5.50242ZM9.4998 6H17.4998V16H19.4998V4H9.4998V6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopyLine);
export default __webpack_public_path__ + "static/media/file-copy-line.470a18fffbd9e4f75381ea80ae2e9fa1.svg";
export { ForwardRef as ReactComponent };